import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class SnTags extends SnModel {
  @Expose()
  public name: string;

  @Expose()
  public count: number;

  @Expose()
  public id: string;

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }
}
